import { ActionCreator } from 'store/redux/ActionCreators';
import { ApplicationsBySeason } from './types/state';

export enum ApplicationTreatmentAction {
  RequestApplicationTreatments = 'REQUEST_APPLICATION_TREATMENTS',
  FetchingApplicationTreatments = 'FETCHING_APPLICATION_TREATMENTS',
  ReceiveApplicationTreatments = 'RECEIVE_APPLICATION_TREATMENTS',
}

export interface ReceiveApplications {
  type: ApplicationTreatmentAction.ReceiveApplicationTreatments;
  payload: ApplicationsBySeason;
}

export function receiveApplicationTreatments(
  applicationsBySeason: ApplicationsBySeason
): ReceiveApplications {
  return {
    type: ApplicationTreatmentAction.ReceiveApplicationTreatments,
    payload: applicationsBySeason,
  };
}

export interface RequestApplications {
  type: ApplicationTreatmentAction.RequestApplicationTreatments;
  payload: { fieldUUID: string };
}

export function requestApplicationTreatments(fieldUUID: string): RequestApplications {
  return {
    type: ApplicationTreatmentAction.RequestApplicationTreatments,
    payload: { fieldUUID }
  };
}

export interface FetchingApplications {
  type: ApplicationTreatmentAction.FetchingApplicationTreatments;
}

export function fetchingApplicationTreatments(): FetchingApplications {
  return {
    type: ApplicationTreatmentAction.FetchingApplicationTreatments
  };
}

export type ApplicationTreatmentActions = RequestApplications | ReceiveApplications | FetchingApplications;

export interface ApplicationTreatmentActionsCreators {
  requestApplicationTreatments: ActionCreator<
    { fieldUUID: string },
    RequestApplications
  >;
  receiveApplicationTreatments: ActionCreator<
    { applicationsBySeason: ApplicationsBySeason },
    ReceiveApplications
  >;
  fetchingApplicationTreatments: ActionCreator<
    undefined,
    FetchingApplications
  >;
}
